import { render } from "./NotFound.vue?vue&type=template&id=d9db3d2c"
import script from "./NotFound.vue?vue&type=script&lang=js"
export * from "./NotFound.vue?vue&type=script&lang=js"

import "./NotFound.vue?vue&type=style&index=0&id=d9db3d2c&lang=css"

import exportComponent from "/home/runner/work/youyinnn.github.io/youyinnn.github.io/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__